import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import NoItemResult from '../../../components/results/NoItemResult';
import { useAddUserDrawer } from './RoleAddUserDrawer';

export type RoleUserEmptyListProps = { role: RoleSpecsFragment };

const RoleUserEmptyList = ({ role }: RoleUserEmptyListProps) => {
    const { t } = useTranslation(['roleDetails']);
    const addUserDrawer = useAddUserDrawer(role);

    return (
        <NoItemResult
            extra={
                <>
                    <Button onClick={addUserDrawer.open} type="primary">
                        {t('roleDetails:tabs.users.noData.action')}
                    </Button>
                    {addUserDrawer.render()}
                </>
            }
            subTitle={t('roleDetails:tabs.users.noData.message')}
        />
    );
};

export default RoleUserEmptyList;
